import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import "./css/Failure.css";
import { apiClient } from "../config/api.client";

const Success = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const { user } = useSelector((state) => state.user);

  const getUserData = async () => {
    apiClient
      .post(
        "/user/getUserData",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setForm(res.data.data.user);
        } else {
          localStorage.removeItem("token");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <div className="failure-container success-container ">
      <TaskAltOutlinedIcon className="icon" />
      <h4>Order Successful</h4>
      <p className="m-0">Thank You for Your Order, {form?.fname}!</p>
      <p className="my-3">
        {isMobile ? (
          <Link to="/reports?type=purchase">View Order History</Link>
        ) : (
          <Link to="/orders">View Order History</Link>
        )}
      </p>
      <div className="actionbtns">
        <button onClick={() => navigate("/")}>Continue Ordering</button>
      </div>
    </div>
  );
};

export default Success;
